import apiClient from './apiConfig';

export interface RewardRedemptionRequest {
  userId: number;
  rewardId: number;
  notes?: string;
}

export interface RewardRedemptionResponse {
  success: boolean;
  data: {
    id: number;
    redemption_code: string;
    user_id: number;
    reward_id: number;
    points_used: number;
    status: string;
    notes?: string;
    created_at: string;
  };
  message: string;
}

/**
 * Request a reward redemption for a user (backoffice)
 */
export const requestRewardRedemption = async (
  request: RewardRedemptionRequest
): Promise<RewardRedemptionResponse> => {
  const response = await apiClient.post('/rewards/redemptions/request', {
    user_id: request.userId,
    reward_id: request.rewardId,
    notes: request.notes,
  });
  return response.data;
};

/**
 * Validate a redemption code
 */
export const validateRedemptionCode = async (code: string): Promise<any> => {
  const response = await apiClient.get(`/rewards/redemptions/validate/${code}`);
  return response.data;
};

/**
 * Confirm a redemption
 */
export const confirmRedemption = async (code: string, notes?: string): Promise<any> => {
  const response = await apiClient.post(`/rewards/redemptions/confirm/${code}`, { notes });
  return response.data;
};

/**
 * Cancel a redemption and refund points
 */
export const cancelRedemption = async (code: string): Promise<any> => {
  const response = await apiClient.post(`/rewards/redemptions/cancel/${code}`);
  return response.data;
};
